import React, { useEffect, useState } from 'react';
import './auth.css';
import { useAuth } from './AuthContext';

const SignIn: React.FC = () => {
  const { signIn, showSignUp, showLanding, federatedSignIn, consumeFlash } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  // One-shot notice from AuthContext (e.g. "your session expired").
  // Read on mount and immediately cleared so a refresh doesn't show it again.
  useEffect(() => {
    const flash = consumeFlash();
    if (flash) setInfo(flash);
  }, [consumeFlash]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>Welcome back</h1>
        <p className="subtitle">Sign in to keep your streak going</p>
        {info && <div className="auth-message info">{info}</div>}
        <button
          className="primary"
          type="button"
          style={{ width: '100%', marginBottom: 4 }}
          onClick={() => federatedSignIn('Google')}
        >
          Continue with Google
        </button>
        <div className="auth-divider"><span>or</span></div>
        <form onSubmit={submit}>
          <label htmlFor="email">Email</label>
          <input
            id="email" type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
          <label htmlFor="password">Password</label>
          <input
            id="password" type="password" required autoComplete="current-password"
            value={password} onChange={(e) => setPassword(e.target.value)}
          />
          <button className="primary" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        {error && <div className="auth-message error">{error}</div>}
        <div className="auth-footer">
          New here?{' '}
          <button className="link" type="button" onClick={showSignUp}>
            Create an account
          </button>
        </div>
        <div className="auth-footer" style={{ marginTop: 6 }}>
          <button className="link" type="button" onClick={showLanding}>
            ← back to home
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
